import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

type ConnectRemoteLockUserRequest = {
  clientId: string
  remoteLockId: string
}

const connectRemoteLockUser = async (data: ConnectRemoteLockUserRequest) => {
  const response = await authAPI.post('/remote-lock/connect', data)
  return response.data
}

export const useConnectRemoteLockUser = () =>
  useMutation({
    mutationFn: connectRemoteLockUser,
  })
